import type { PropsWithChildren } from 'react';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { TitleSection } from '@mentimeter/question-modules-shared';
import { useOpenEndedPresentationContext } from '../../OpenEndedPresentationContext';

type TitleSectionProps = { showTextSizeDropdown?: boolean } & Omit<
  BoxT,
  'title'
>;

export const OpenEndedTitleDataHandler = ({
  children,
  showTextSizeDropdown,
  ...rest
}: PropsWithChildren<TitleSectionProps>) => {
  const { title, styledTitle, description, label, textSizeOffset } =
    useOpenEndedPresentationContext();

  return (
    <TitleSection
      title={title}
      styledTitle={styledTitle}
      description={description}
      label={label}
      fontSizeOffset={textSizeOffset}
      showTextSizeDropdown={showTextSizeDropdown ?? false}
      {...rest}
    >
      {children}
    </TitleSection>
  );
};
